<template>
  <div class="content">
    <div class="container-fluid">
      <!--<OrganizationChart :value="data1" :collapsible="true" class="company" selectionMode="single" :selectionKeys.sync="selection"
          @node-select="onNodeSelect" @node-unselect="onNodeUnselect" @node-collapse="onNodeCollapse" @node-expand="onNodeExpand">
          <template #person="slotProps">
              <div class="node-header ui-corner-top">{{slotProps.node.data.label}}</div>
              <div class="node-content">
                  <img :src="slotProps.node.data.avatar" width="32">
                  <div>{{slotProps.node.data.name}}</div>
              </div>
          </template>
          <template #default="slotProps">
              <span>{{slotProps.node.data.label}}</span>
          </template>
      </OrganizationChart>-->



      <a-spin :spinning="loading" :delay="500">
        <div class="spin-content">
          <OrganizationChart v-if="req_complete" :value="data" :collapsible="true" class="company" selectionMode="single" :selectionKeys.sync="selection"
            @node-select="onNodeSelect" @node-unselect="onNodeUnselect" @node-collapse="onNodeCollapse" @node-expand="onNodeExpand">
            <template #person="slotProps">
                <div class="node-header ui-corner-top">{{slotProps.node.data.label}}</div>
                <div class="node-content">
                    <div v-html="slotProps.node.data.name"></div>
                </div>
                <div class="delete-node" v-if="!slotProps.node.data.new && slotProps.node.data.top_id">
                  <a-popconfirm
                    @confirm="deleteNode(slotProps.node.data)"
                    title="Silmek istediğinize emin misiniz?"
                    ok-text="Evet"
                    cancel-text="Hayır">
                    <!--<a @click="deleteNode(slotProps.node.data)"></a>-->
                    <a> <i class="p-node-toggler-icon pi pi-times"></i> </a>
                  </a-popconfirm>
                </div>
                <div class="branch-panel" v-if="slotProps.node.data.branches">
                  <div class="branch-panel-header">Şube</div>
                  <div class="branch-tree">
                    <div class="branch-node" v-for="branch in slotProps.node.data.branches" :key="branch.id">
                      <div class="branch-box">
                        <span>{{branch.name}}</span>
                        <a-popconfirm
                          @confirm="deleteNode({segment_id: branch.id})"
                          title="Silmek istediğinize emin misiniz?"
                          ok-text="Evet"
                          cancel-text="Hayır">
                          <a class="branch-delete"> <i class="p-node-toggler-icon pi pi-times"></i> </a>
                        </a-popconfirm>
                      </div>
                    </div>
                    <div class="branch-node">
                      <div class="branch-box branch-add" @click="openAddBranchModal(slotProps.node.data)">
                        <i class="pi pi-plus-circle"></i> Yeni Şube Ekle
                      </div>
                    </div>
                  </div>
                </div>
            </template>
            <template #default="slotProps">
                <span>{{slotProps.node.data.label}}</span>
            </template>
        </OrganizationChart>
        </div>
      </a-spin>
    </div>
    <a-modal
      :title="modal.title"
      :visible="modal.visible"
      :confirm-loading="modal.confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <p>
        <a-form-model
          ref="ruleForm"
          :model="form"
          :rules="rules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          labelAlign="left"
        >
          <a-form-model-item ref="name" label="İsim" prop="name">
            <a-input
              placeholder="İsim"
              v-model="form.name"
              @blur="
                () => {
                  $refs.name.onFieldBlur();
                }
              "
            />
          </a-form-model-item>
        </a-form-model>
      </p>
    </a-modal>
  </div>
</template>
<script>
  import OrganizationChart from 'primevue/organizationchart';
  export default {
     mounted() {
      console.log("mounted organization chart")
      const self = this
      self.requestChartData()
    },
    computed: {

    },
    components: {
      OrganizationChart
    },
    methods: {
      requestChartData(){
        const self = this;
        self.loading = true
        self.$store.dispatch("Segments/requestSegmentIndex").then((a) => {
          self.$store.dispatch("Segments/requestSegmentTypeIndex").then((b) => {
            self.segments = a.segments
            self.segmentTypes = b.segmentTypes
            self.configureChart()
            self.loading = false
          })
        })
      },
      handleOk(e) {
        const self = this
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            self.confirmLoading = true
            self.$store.dispatch("Segments/requestSegmentCreate", {
              name: self.form.name,
              top_segment_id: self.modal.top_id,
              segment_type_id: self.modal.node_type_id
            }).then((user)=> {
              self.$notification['success']({
                message: 'Segment Ekleme',
                description:
                  'Segment başarılı bir şekilde oluşturuldu 😊',
              });
              self.requestChartData()
              self.handleCancel();

            }).catch(()=> {
              self.$notification['error']({
                message: 'Segment Ekleme',
                description:
                  'Segment eklenirken bir hata oluştu :/',
              });
            }).finally(()=> {
              self.modal.confirmLoading = false
            })
          }
        })
      },
      handleCancel(e) {
        const self = this;
        self.modal = {
          title: '',
          visible: false,
          text: '',
          confirmLoading: false,
          top_id: null,
          node_type_id: null,
        }
        self.form.name = ''
      },
      configureChart(){
        const self = this

        var data = {}

        // The visible root is the segment whose parent is not present in the
        // (possibly scope-restricted) segment list: the organization's real
        // root for an organizationAdmin, or the top of a segmentAdmin's own
        // managed subtree, since their parent segment is outside their scope.
        var visibleIds = self.segments.map(item => item.id)
        let main_node = self.segments.find(item => !item.top_segment_id || !visibleIds.includes(item.top_segment_id))
        if (!main_node) {
          self.req_complete = true
          return
        }
        let main_node_type = self.segmentTypes.find(item => item.id == main_node.segment_type_id) || {}

        data.type = "person";
        data.styleClass = "p-person";
        data.key = main_node.id;
        data.data = {new: false, label: main_node_type.name, name: main_node.name}

        var next = self.getChildren(main_node.id, main_node.segment_type_id)
        data.children = next

        self.data = data
        self.req_complete = true

      },
      maxSegmentRank(){
        const self = this
        if (!self.segmentTypes.length) return 0
        return Math.max(...self.segmentTypes.map(t => t.rank))
      },
      getChildren(top_id, node_type_id){
        const self = this
        var s_segments = self.segments.filter(item => item.top_segment_id == top_id )
        var children = [];

        var node_type = {}
        const top_segment = self.segments.find(item => item.id == top_id)
        const maxRank = self.maxSegmentRank()

        s_segments.forEach((item) => {

          node_type = self.segmentTypes.find(a => a.id == item.segment_type_id)
          let child_data = {
            key: top_id+'_'+item.id,
            type: "person",
            styleClass: "p-person active",
            data: {
              new: false,
              label: node_type ? node_type.name : 'no-name',
              name: item.name,
              top_id: top_id,
              node_type_id: node_type.id,
              segment_id: item.id
            }
          }

          if (node_type && node_type.rank === maxRank - 1) {
            // This node's own children sit at the leaf (Şube) rank - list them
            // vertically inside the node's box instead of as horizontal
            // org-chart siblings.
            child_data.data.branches = self.segments
              .filter(s => s.top_segment_id == item.id)
              .map(s => ({ id: s.id, name: s.name }))
          } else {
            let next = self.getChildren(item.id, node_type.id)
            child_data.children = next
          }

          children.push(child_data)
        })

        var sorted_segment_type = self.segmentTypes.slice().sort(function(a, b) {
          return a.rank - b.rank
        });
        var _node_type = sorted_segment_type.find(a => a.id == node_type_id)
        if(_node_type){
          var _node = sorted_segment_type.find(item => item.rank > _node_type.rank)

          if(_node){
            children.push({
              key: top_id+'_'+self.$randUniqueID(),
              type: "person",
              styleClass: "p-person",
              data: {new: true, label: ('Yeni '+ _node.name ), name: '<i class="p-node-toggler-icon pi pi-plus-circle"></i>', top_id: top_id, node_type_id: _node.id}
            })
          }
        }

        return children
      },
      onNodeSelect(node) {
        if(!node.data.new) return
        this.configureModal(node)
      },
      onNodeUnselect(node) {
        if(!node.data.new) return
        this.configureModal(node)
      },
      deleteNode(node){
        const self = this
        self.$store.dispatch("Segments/requestSegmentDelete", {
          segment_id: node.segment_id
        }).then((user)=> {
          self.requestChartData()

        }).catch(()=> {
          self.$notification['error']({
            message: 'Segment Silme',
            description:
              'Segment silinirken bir hata oluştu :/',
          });
        }).finally(()=> {
        })
      },
      configureModal(node){
        const self = this
        self.modal.title = node.data.label+ " Oluştur"
        self.modal.visible = true
        self.modal.top_id = node.data.top_id
        self.modal.node_type_id = node.data.node_type_id
      },
      openAddBranchModal(nodeData){
        const self = this
        var sorted_segment_type = self.segmentTypes.slice().sort(function(a, b) {
          return a.rank - b.rank
        });
        var _node_type = sorted_segment_type.find(a => a.id == nodeData.node_type_id)
        if (!_node_type) return
        var branch_type = sorted_segment_type.find(item => item.rank > _node_type.rank)
        if (!branch_type) return

        self.modal.title = branch_type.name + " Oluştur"
        self.modal.visible = true
        self.modal.top_id = nodeData.segment_id
        self.modal.node_type_id = branch_type.id
      },
      onNodeExpand(node) {
        console.log('Node Expanded: ', node.data.label)
      },
      onNodeCollapse(node) {
        console.log('Node Collapsed: ', node.data.label)
      }
    },
    data () {
      return {
        labelCol: { span: 4 },
        wrapperCol: { span: 10 },
        other: '',
        form: {
          name: '',
        },
        rules: {
          name: [
            { required: true, message: 'İsim alanını boş bırakmayınız', trigger: 'blur' },
            { min: 3, max: 20, message: 'İsim alanı min 3, max 20 karakter uzunluğunda olabilir', trigger: 'blur' },
          ],
        },
        modal: {
          title: '',
          visible: false,
          text: '',
          confirmLoading: false,
          top_id: null,
          node_type_id: null,
        },
        segments: [],
        segmentTypes: [],
        req_complete: false,
        loading: false,
        data: {},
        data1: {
            key: '0',
            type: 'person',
            styleClass: 'p-person',
            data: {label: 'CEO', name: 'Walter White', avatar: 'https://www.primefaces.org/primevue-v2/demo/images/organization/walter.jpg'},
            children: [
                {
                    key: '0_0',
                    type: 'person',
                    styleClass: 'p-person',
                    data: {label: 'CFO', name:'Saul Goodman', avatar: 'https://www.primefaces.org/primevue-v2/demo/images/organization/saul.jpg'},
                    children:[{
                        key: '0_0_0',
                        data: {label: 'Tax'},
                        selectable: false,
                        styleClass: 'department-cfo'
                    },
                    {
                        key: '0_0_1',
                        data: {label: 'Legal'},
                        selectable: false,
                        styleClass: 'department-cfo'
                    }],
                },
                {
                    key: '0_1',
                    type: 'person',
                    styleClass: 'p-person',
                    data: {label: 'COO', name:'Mike E.', avatar: 'https://www.primefaces.org/primevue-v2/demo/images/organization/mike.jpg'},
                    children:[{
                        key: '0_1_0',
                        data: {label: 'Operations'},
                        selectable: false,
                        styleClass: 'department-coo'
                    }]
                },
                {
                    key: '0_2',
                    type: 'person',
                    styleClass: 'p-person',
                    data: {label: 'CTO', name:'Jesse Pinkman', avatar: 'https://www.primefaces.org/primevue-v2/demo/images/organization/jesse.jpg'},
                    children:[{
                        key: '0_2_0',
                        data: {label: 'Development'},
                        selectable: false,
                        styleClass: 'department-cto',
                        children:[{
                            key: '0_2_0_0',
                            data: {label: 'Analysis'},
                            selectable: false,
                            styleClass: 'department-cto'
                        },
                        {
                            key: '0_2_0_1',
                            data: {label: 'Front End'},
                            selectable: false,
                            styleClass: 'department-cto'
                        },
                        {
                            key: '0_2_0_2',
                            data: {label: 'Back End'},
                            selectable: false,
                            styleClass: 'department-cto'
                        }]
                    },
                    {
                        key: '0_2_1',
                        data: {label: 'QA'},
                        selectable: false,
                        styleClass: 'department-cto'
                    },
                    {
                        key: '0_2_2',
                        data: {label: 'R&D'},
                        selectable: false,
                        styleClass: 'department-cto'
                    }]
                }
            ]
        },
        selection: {}
      }
    }
  }
</script>
<style lang="scss" scoped>
  .spin-content {
    border: 1px solid #91d5ff;
    background-color: #e6f7ff;
    padding: 30px;
  }
  :deep(.p-organizationchart) {

    .delete-node{
      position: absolute;
      top: -10px;
      left: -10px;
      a{
        background-color: #fff;
        color: #ff0000;
        border: 1px solid #ff0000;
        border-radius: 10px;
        padding: 2px;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        i{
          font-weight: bolder;
          font-size: 8px;
        }
      }
    }
    .p-person {
        padding: 0;
        border: 0 none;
    }

    .node-header, .node-content {
        padding: .5em .7rem;
    }

    .node-header {
        background-color: #495ebb;
        color: #ffffff;
    }

    .node-content {
        text-align: center;
        border: 1px solid #dee2e6;
        div {
          margin: 5px 0;
          color: #888888;
        }
    }

    .node-content img {
        border-radius: 50%;
    }

    .branch-panel {
      margin-top: 12px;
      border-top: 1px solid #dee2e6;
      background: #f8f9fb;
    }

    .branch-panel-header {
      background: #495ebb;
      color: #fff;
      padding: 6px 8px;
      text-align: center;
      font-size: 12px;
    }

    .branch-tree {
      position: relative;
      padding: 10px 10px 10px 26px;
      text-align: left;
    }

    .branch-tree::before {
      content: '';
      position: absolute;
      left: 10px;
      top: 0;
      bottom: 15px;
      width: 1px;
      background: #c7ccdb;
    }

    .branch-node {
      position: relative;
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .branch-node::before {
      content: '';
      position: absolute;
      left: -16px;
      top: 15px;
      width: 16px;
      height: 1px;
      background: #c7ccdb;
    }

    .branch-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid #dee2e6;
      border-radius: 4px;
      padding: 6px 10px;
      font-size: 12px;
      color: #555;
      background: #fff;
    }

    .branch-delete {
      color: #ff0000;
      cursor: pointer;
      margin-left: 8px;
      i {
        font-size: 8px;
      }
    }

    .branch-add {
      cursor: pointer;
      color: #495ebb;
      border-style: dashed;
      justify-content: flex-start;
      gap: 6px;
      &:hover {
        background-color: #f5f6fb;
      }
    }
}
</style>
